import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../hooks/GlobalProvider";
import { RiHome5Fill, RiAccountCircleFill } from "react-icons/ri";
import { MdTipsAndUpdates, MdAssignment } from "react-icons/md";
import { FaLeaf, FaGear } from "react-icons/fa6";

function BottomNavbar() {
  const location = useLocation();
  const { user } = useAuth();

  // Hide navbar on certain paths
  const hiddenPaths = ["/", "/admin-dashboard", "/login", "/signup"];
  if (hiddenPaths.includes(location.pathname)) return null;

  const NavItem = ({ to, icon: Icon, label }) => {
    const isActive = location.pathname === to;
    
    return (
      <Link
        to={to}
        className={`relative flex flex-col items-center justify-center min-w-[64px] py-1 transition-all duration-300 ${
          isActive ? "text-secondary scale-110" : "text-gray-500 hover:text-secondary/70"
        }`}
      >
        {isActive && (
          <div className="absolute -top-1 w-1 h-1 bg-secondary rounded-full shadow-[0_0_8px_#ffcc00] animate-pulse"></div>
        )}
        
        <div className={`p-1.5 rounded-xl transition-all ${isActive ? "bg-secondary/10" : "bg-transparent"}`}>
          <Icon size={isActive ? 22 : 20} />
        </div>
        
        <span className={`text-[8px] font-black uppercase tracking-widest mt-0.5 ${isActive ? "opacity-100" : "opacity-60"}`}>
          {label}
        </span>
      </Link>
    );
  };

  return (
    <nav className="fixed bottom-4 left-1/2 -translate-x-1/2 w-[92%] max-w-md z-[100]">
      <div className="bg-primary/90 backdrop-blur-xl border border-white/5 rounded-[2rem] px-4 py-2 shadow-[0_20px_50px_rgba(0,0,0,0.5)] flex items-center justify-around">
        <NavItem to="/dashboard" icon={RiHome5Fill} label="Home" />
        <NavItem to="/new" icon={MdTipsAndUpdates} label="New" />
        <NavItem to="/farming" icon={FaLeaf} label="Farm" />
        <NavItem to="/report" icon={MdAssignment} label="Report" />
        <NavItem
          to={user ? "/settings" : "/signup"}
          icon={user ? FaGear : RiAccountCircleFill}
          label={user ? "Tools" : "Join"}
        />
      </div>
    </nav>
  );
}

export default BottomNavbar;
